var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c("el-col", { attrs: { sm: 24, md: 24 } }, [
            _c("p", [
              _vm._v(
                "\n                Your submission was saved successfully. Your form reference\n                id is "
              ),
              _c("strong", [_vm._v(_vm._s(_vm.formId))]),
              _vm._v(".\n            "),
            ]),
            _vm._v(" "),
            _vm.paymethod == "bank"
              ? _c(
                  "div",
                  [
                    _vm._v(
                      "\n                After we receive your submission and check all materials an\n                invoice will be sent to your email. Please forward at\n                "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "mailto:contact@globaldesignnews.com" },
                      },
                      [_vm._v("contact@globaldesignnews.com")]
                    ),
                    _vm._v(
                      "\n                the bank transfer receipt adding the ID of your entry as\n                reference number."
                    ),
                    _c("BR"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "bankdocument",
                        attrs: {
                          href: "https://awardapplication.com/pdf/Bank_Transfer_TCA_FH.pdf",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Download Bank payment details")]
                    ),
                  ],
                  1
                )
              : _c("div", [
                  _vm._v(
                    "\n                After we receive your submission and check all materials an\n                invoice will be sent to your email.\n            "
                  ),
                ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                If you wish to apply for more than one projects to our award\n                program, please return to the\n                "
              ),
              _c("a", { attrs: { href: "https://awardapplication.com/" } }, [
                _vm._v("AWARD APPLICATION HOME page"),
              ]),
              _vm._v(".\n            "),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }